import { lazy } from "react";
const Users = lazy(() => import("../pages/Users"));
const UserDetails = lazy(() => import("../pages/Users/UserDetails"));
const Course = lazy(() => import("../pages/Course"));
const CourseDetail = lazy(() => import("../pages/Course/CourseDetails"));
const Skill = lazy(() => import("../pages/Skill"));
const Add_Admin_Constributor = lazy(() =>
  import("../pages/Add_Admin-constributor/AddUsers/index")
);

const ApplicantDetails = lazy(() =>
  import("../pages/Applications/ApplicantDetails/index")
);
const Certificate_ApplicantDetails = lazy(() =>
  import("../pages/Applications/CertificateApplication/index")
);
const Dl_ApplicantDetails = lazy(() =>import("../pages/Applications/DlApplication/index"));

const Contributor = lazy(() => import("../pages/Add_Admin-constributor"));
const Applications = lazy(() => import("../pages/Applications"));
const Degree = lazy(() => import("../pages/Degree"));
const Events = lazy(() => import("../pages/Events"));
const Reports = lazy(() => import("../pages/Reports"));
const FreeClassesList = lazy(() => import("../pages/Reports/FreeClassesList"));
const AllCourses = lazy(() => import("../pages/Reports/AllCourses"));
const AllUserList = lazy(() => import("../pages/Reports/AllUserList"));
const IndividualCourse = lazy(() =>
  import("../pages/Reports/IndividualCourses")
);
const CourseReport = lazy(() =>
  import("../pages/PreCollegeReports/CourseReport")
);
const SubscriptionsPurchases = lazy(() =>
  import("../pages/Reports/Subscription_purchase")
);
const ApplicationSubmitted = lazy(() =>
  import("../pages/PreCollegeReports/ApplicationSubmit")
);
const DlApplicationSubmitted = lazy(() =>
  import("../pages/DlReports/ApplicationSubmit")
);
const CourseEnrollment = lazy(() =>
  import("../pages/PreCollegeReports/CourseEnrollment")
);
const DlCourseEnrollment = lazy(() =>
  import("../pages/DlReports/CourseEnrollment")
);
const SalesCoursePurchase = lazy(() =>
  import("../pages/PreCollegeReports/Sales")
);
const DlSalesCoursePurchase = lazy(() => import("../pages/DlReports/Sales"));
const EventDetail = lazy(() => import("../pages/Events/EventDetails"));
const FreeClasses = lazy(() => import("../pages/FreeClasses"));
const FreeClassDetail = lazy(() =>
  import("../pages/FreeClasses/freeClassDetails")
);
const ActionLogs = lazy(() => import("../pages/ActionLogs"));
const ThoughtLeaders = lazy(() => import("../pages/ThoughtLeaders"));
const AccountActivity = lazy(() => import("../pages/AccountActivity"));
const Groups = lazy(() => import("../pages/Groups"));
const Submissions = lazy(() => import("../pages/Submissions"));
const Settings = lazy(() => import("../pages/Settings"));
const MyProfile = lazy(() => import("../pages/MyProfile"));
const RequestList = lazy(() => import("../pages/RequestList"));
const Certificates = lazy(() => import("../pages/Certificates"));
const ResetPassword = lazy(() => import("../pages/ResetPassword"));

export const adminRoutes = [
  { path: "/users", Component: Users, title: "Users" },
  { path: "/applicants", Component: Users, title: "Applicants" },
  { path: "/user-details", Component: UserDetails, title: "User Details" },
  { path: "/skills", Component: Skill, title: "Skill" },
  {
    path: "/Admin-Contributor",
    Component: Add_Admin_Constributor,
    title: "Add Admin Contributor",
  },
  {
    path: "/contributors",
    Component: Contributor,
    title: "Contributors",
  },
  {
    path: "/applicant-details/:id",
    Component: ApplicantDetails,
    title: "Applicant Details",
  },
  {
    path: "/certificate-applicant-details/:id",
    Component: Certificate_ApplicantDetails,
    title: "Applicant Details",
  },
  {
    path: "/dl-applicant-details/:id",
    Component: Dl_ApplicantDetails,
    title: "Applicant Details",
  },
  {
    path: "/applications",
    Component: Applications,
    title: "Applications",
  },
  { path: "/courses", Component: Course, title: "Course" },
  { path: "/program", Component: Course, title: "Program" },
  { path: "/program/:id", Component: CourseDetail, title: "Program" },
  { path: "/event", Component: Course, title: "Events" },
  { path: "/event/:id", Component: CourseDetail, title: "Program" },
  { path: "/courses/:id", Component: CourseDetail, title: "Edit Course" },
  { path: "/add-courses", Component: CourseDetail, title: "Add Course" },
  { path: "/add-event", Component: CourseDetail, title: "Add Event" },
  { path: "/add-program", Component: CourseDetail, title: "Add Program" },
  { path: "/events", Component: Events, title: "Events" },
  { path: "/events/:id", Component: EventDetail, title: "Events" },
  { path: "/add-events", Component: EventDetail, title: "Add Event" },
  { path: "/reports", Component: Reports, title: "Reports" },
  {
    path: "/subscriptions",
    Component: SubscriptionsPurchases,
    title: "Subscriptions Purchases",
  },
  { path: "/all-course", Component: AllCourses, title: "All Courses" },
  {
    path: "/all-individual_course",
    Component: IndividualCourse,
    title: "Individual Course",
  },
  { path: "/userList", Component: AllUserList, title: "All UserList" },
  {
    path: "/freeClassList",
    Component: FreeClassesList,
    title: "Free Classes List",
  },
  {
    path: "/application-submitted",
    Component: ApplicationSubmitted,
    title: "Application submitted List",
  },
  {
    path: "/dl-application-submitted",
    Component: DlApplicationSubmitted,
    title: "Application submitted List",
  },
  {
    path: "/dl-course-enrollment",
    Component: DlCourseEnrollment,
    title: "Course Enrollment List",
  },
  {
    path: "/course-enrollment",
    Component: CourseEnrollment,
    title: "Course Enrollment List",
  },
  {
    path: "/sales",
    Component: SalesCoursePurchase,
    title: "Sales List",
  },
  {
    path: "/dl-sales",
    Component: DlSalesCoursePurchase,
    title: "Sales List",
  },
  {
    path: "/course-report",
    Component: CourseReport,
    title: "Course Report",
  },
  { path: "/free-class", Component: FreeClasses, title: "Free Classes" },
  {
    path: "/free-class/:id",
    Component: FreeClassDetail,
    title: "Free Classes",
  },
  {
    path: "/add-free-classes",
    Component: FreeClassDetail,
    title: "Add Free Class",
  },
  {
    path: "/discourse-logs",
    Component: ActionLogs,
    title: "Discourse Activity",
  },
  {
    path: "/account-activity",
    Component: AccountActivity,
    title: "Account Activity",
  },
  {
    path: "/thought-leaders",
    Component: ThoughtLeaders,
    title: "Thought leaders",
  },
  { path: "/groups", Component: Groups, title: "Group" },
  { path: "/submissions", Component: Submissions, title: "Submissions" },
  { path: "/settings", Component: Settings, title: "Settings" },
  { path: "/my-profile", Component: MyProfile, title: "MyProfile" },
  { path: "/request-list", Component: RequestList, title: "Request List" },
  { path: "/certificates", Component: Certificates, title: "Certificates" },
];


export const publicRoutes = [
  { path: '/reset-password/:token', Component: ResetPassword, title: "Reset Password" },
];